function initLandCode(targetClass) {

  if (!$(targetClass).length) {
    console.log('no class in dom');
    return;
  }

  var identifier = targetClass.slice(1);

  $(targetClass).hide();

  // DONE: Create advance country code html
  // DONE: Crete list of country codes
  var $ul = $('<ul/>'),
    list = [],
    selectedOption;

  $.each($(targetClass).find('option'), function(i, option) {
    var $option = $(option),
      selected = false;
    if ($option.is(':selected')) {
      selectedOption = $option;
      selected = true;
    }
    list.push('<li><a href="javascript:void(0)" class="jq-land-code-' + identifier + (selected ? ' active' : '') + ' jq-land-code keypress' + '" data-value="' + $option.val() + '" data-country="' + $option.attr('data-country') + '" data-country-name="' + $option.attr('data-country-name').toLowerCase() + '" data-code="' + $option.attr('data-code') + '"><span class="flag-wrap"><span class="flag flag-' + $option.attr('data-country') + '"></span></span>' + '<span class="jq-land-code-number"> +' + $option.attr('data-code') + '</span>' + $option.attr('data-country-name') + '</a></li>');
  });
  $ul.append(list.join(""));

  // DONE: Crete list of country codes container
  var $flagSelectionListContainer = $('<div class="jq-flag-selection-list jq-flag-selection-list-' + identifier + '" />').append($ul);

  // DONE: Crete flag container
  var $flagSelectionContainer = $('<a href="javascript:void(0)" class="jq-flag-selection jq-flag-selection-' + identifier + '"/>').html('<span class="jq-selected-flag jq-selected-flag-' + identifier + ' flag flag-' + selectedOption.attr('data-country') + '"></span><span class="jq-selected-country-code jq-selected-country-code-' + identifier + '"> +' + selectedOption.attr('data-code') + '</span> <span class="arrow-down"></span>');

  // DONE: Create advance country code container
  var $advanceCountryCode = $('<div class="advance-land-code" />').append($flagSelectionContainer).append($flagSelectionListContainer);

  // DONE: Append after the target element
  $(targetClass).after($advanceCountryCode);

  var $flagSelectionBtn = $('.jq-flag-selection-' + identifier),
    $flagSelectionList = $('.jq-flag-selection-list-' + identifier),
    $flagSelectionItems = $('.jq-land-code-' + identifier),
    $selectedFlag = $('.jq-selected-flag-' + identifier),
    $selectedCode = $('.jq-selected-country-code-' + identifier),
    $target = $(targetClass);

  $flagSelectionBtn.on('click', function(e) {
    e.stopPropagation();
    $('.jq-flag-selection-list').hide(1);
    $flagSelectionList.toggle();
    /*var $target = $('.jq-flag-selection-list'),
     $selectedItem = $target.find('.jq-land-code.keypress.active');

     // Make sure to see what is active. Scroll to it
     var selectedItemTop = $selectedItem.offset().top,
     parentTop = $target.offset().top;

     $target.scrollTop($target.scrollTop() + (selectedItemTop - parentTop));*/
    $('.jq-land-code-' + identifier).removeClass('active');
    $('.jq-land-code-' + identifier + '[data-value=' + $(targetClass).find('option:selected').val() + ']').trigger('mouseover');

    landCodeEnsureVisibility();
  });

  $flagSelectionItems.on('click', function() {
    var _this = $(this);
    $flagSelectionList.hide(1, resetArrLetter());
    $selectedFlag.removeClass();
    $selectedFlag.addClass('flag flag-' + _this.data('country'));
    $selectedCode.text(' +' + _this.attr('data-code'));
    $('.jq-land-code-' + identifier).removeClass('active');
    _this.addClass('active');
    $target.val(_this.attr('data-value')); // Sync advance county code to country code
  });

  $flagSelectionItems.on('mouseover', function() {
    var _this = $(this);
    $('.jq-land-code-' + identifier).removeClass('active');
    _this.addClass('active');
  });

  // Sync county code to advance country code
  $target.on('change', function() {
    var _this = $(this);
    $('.jq-land-code-' + identifier + '[data-value="' + _this.val() + '"]').trigger('click');
  });

  $(document).on('click', function(e) {
    e.stopPropagation();
    if (e.target.className != ('jq-flag-selection-' + identifier) || e.target.parentNode.className != ('jq-flag-selection-' + identifier)) {
      $flagSelectionList.hide(1, resetArrLetter());
    }
  });

}

function resetArrLetter() {
  arrLetter = [];
}

var arrLetter = [],
  lastKeypress = 0,
  allowance = 0,
  lastQueryLetterLen = 0,
  ctr = 0;

// Listen to the keyboard press event to select country based on what the user typed
$(document).on('keypress', function(e) {
  // Only run this block of code when .jq-flag-selection-list is visible
  if ($('.jq-flag-selection-list').is(':visible')) {

    e = e || window.event; // consider IE

    var code = e.keyCode || e.which; // consider IE
    var $target = $('.jq-flag-selection-list').filter(':visible');
    var $targetPrev = $target.prev();

    // Reset the array if more than 1 second since the last stroke. So if you first type, "p" and then "h"
    // within 1 second you display "Philippines". But if you type "p", wait 2 seconds and then "h" you first
    // display "Panama" and then "Honduras".

    // Reset the array if there are more than 3 characters already
    if (arrLetter.length == 3 || (+new Date() > +allowance)) {
      arrLetter = [];
    }

    if (+new Date() > +allowance) {
      ctr = 0;
    }

    arrLetter.push(String.fromCharCode(code).toLowerCase());

    $target.find('.jq-land-code').removeClass('active');
    var $selectedItem = $target.find('.jq-land-code.keypress[data-country-name^="' + String(arrLetter.join('')) + '"]:eq(' + ctr + ')');

    if ($selectedItem.length) {
      $selectedItem.addClass('active');

      // Make sure to see what is active. Scroll to it
      var selectedItemTop = $selectedItem.offset().top,
        parentTop = $target.offset().top;

      $target.scrollTop($target.scrollTop() + (selectedItemTop - parentTop));
    } else {
      ctr++;

      // If you type "b" and the selected already starts with "b" then you select the next country
      // starting with "b". If there's no more countries after the selected country starting with "b", then you start over.
      lastQueryLetterLen = $target.find('.jq-land-code.keypress[data-country-name^="' + String(arrLetter[0]) + '"]').length;

      if (ctr > (lastQueryLetterLen - 1)) {
        ctr = 0;
      }

      if (arrLetter.length > 1 && (arrLetter[0] == arrLetter[arrLetter.length - 1].toUpperCase())) {
        $target.find('.jq-land-code').removeClass('active');
        var $newSelItem = $target.find('.jq-land-code.keypress[data-country-name^="' + String(arrLetter[0]) + '"]:eq(' + ctr + ')');
        $newSelItem.addClass('active');
        arrLetter.pop(); // Remove the item of the array
      }
    }

    lastKeypress = new Date(),
      allowance = new Date().setTime(lastKeypress.getTime() + 1000);

    landCodeEnsureVisibility();
    e.preventDefault();
  }
});

// Listen to the keyboard press event to select country based on up/down arrow
$(document).on('keydown', function(e) {
  // Only run this block of code when .jq-flag-selection-list is visible
  if ($('.jq-flag-selection-list').is(':visible')) {
    e = e || window.event; // consider IE

    var $target = $('.jq-flag-selection-list').filter(':visible'),
      $targetPrev = $target.prev(),
      activeNow = $target.find('.jq-land-code.active');

    if (e.which == 38 || e.which == 40) { // 38 = up arrow, 40 = down arrow
      if (e.which == 40) {
        if (activeNow.length == 0) {
          $target.find('.jq-land-code').first().addClass('active');
        } else {
          var next = activeNow.parent().next().find('.jq-land-code');
          if (next.length > 0) {
            next.addClass('active');
          } else {
            next = activeNow.closest('ul').children('li').first().find('.jq-land-code');
            next.addClass('active');
          }
        }
      } else {
        if (activeNow.length == 0) {
          $target.find('.jq-land-code').last().addClass('active');
        } else {
          var prev = activeNow.parent().prev().find('.jq-land-code');
          if (prev.length > 0) {
            prev.addClass('active');
          } else {
            prev = activeNow.closest('ul').children('li').last().find('.jq-land-code');
            prev.addClass('active');
          }
        }
      }

      activeNow.removeClass('active');
      landCodeEnsureVisibility();
      e.preventDefault();
    }

    if (e.which == 13) { // enter
      activeNow.trigger('click');
    }
  }
});

// Show LandCode active selection
function landCodeEnsureVisibility() {
  var $target = $('.jq-flag-selection-list').filter(':visible'),
    $li = $target.find('.jq-land-code.active').parent();

  if ($li.length) {
    var position = $li.position().top;
    var height = $li.innerHeight();

    if (position < 0) {
      $target.scrollTop($target.scrollTop() + position);
    } else if (position + height > $target.innerHeight()) {
      var diff = position + height - $target.innerHeight();
      $target.scrollTop($target.scrollTop() + diff);
    }
  }
}

// Disable LandCode plugin
function setLandCodeDisable(target) {
  if (!$(target).length) {
    console.log('no class in dom');
    return;
  }

  var $target = $(target);

  $target.attr('disabled', 'disabled');
  $target.next('.advance-land-code').addClass('jq-flag-disabled');
}

// Enable LandCode plugin
function unsetLandCodeDisable(target) {
  if (!$(target).length) {
    console.log('no class in dom');
    return;
  }

  var $target = $(target);

  $target.removeAttr('disabled');
  $target.next('.advance-land-code').removeClass('jq-flag-disabled');
}

/* CHANGELOG */
// ----- 06-06-2017 a -------
// CHANGE code: data-land-code tp data-code
// ----- 11-29-2016 b -------
// ADD feature: Always show selected land code when opening selection
// ----- 11-29-2016 a -------
// FIX bug: Alphabet searching not functioning with lowercase letters
//          Show currently selected options
// ----- 11-28-2016 -------
// FIX bug: Alphabet searching not working on multiple instance
//          Select box changes not synching on multiple instance
// ADD feature: Pressing enter would select the selected landcode
// Notes: Add more comments
//        Add keypress class on Singapore land code